<template>
    <div class="service-apply">
        <div class="bread-crumbs">
            <div class="crumbs-item" @click="onOrderList">订单列表</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item" @click="onOrderDetail">订单详情</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item active">售后详情</div>
        </div>

        <div class="apply-body-with-form">
            <div class="top-status-box">
                <div class="step-info">
                    <div class="step-item" v-for="(item,index) in steps" :key="index">
                        <div :class="['line',{'active':item.line_active}]" v-if="index != 0"></div>
                        <div class="dot-info-box">
                            <div :class="['dot',{'active':item.dot_active}]"></div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-detail-body">
                <div class="left-form">
                    <div class="main-status-text">
                        <div v-if="['create'].includes(detail.status_text)" class="status-text">您已成功发起{{detail.type|type_filter}}申请,请等待商家处理</div>
                        <div v-if="detail.status_text == 'wait_user_send'" class="status-text">申请成功,请退货并填写物流信息</div>
                        <div v-if="detail.status_text == 'wait_shop_confirm'" class="status-text">请等待商家收货</div>
                        <div v-if="detail.status_text == 'shop_reject_apply'" class="status-text">很遗憾,商家拒绝了您的{{detail.type|type_filter}}申请</div>
                        <div v-if="detail.status_text == 'shop_reject_receive'" class="status-text">很遗憾,商家拒绝了您的退货</div>
                        <div v-if="detail.status_text == 'cancel'" class="status-text">您已撤销本次售后申请</div>
                        <div v-if="detail.status_text == 'platform_judge'" class="status-text">您已申请平台介入,请等待客服裁决</div>
                        <div v-if="detail.status_text == 'platform_reject'" class="status-text">很遗憾,平台驳回了您的{{detail.type|type_filter}}申请</div>
                        <div class="status-countdown" v-if="['create','wait_user_send','wait_shop_confirm','wait_shop_send','wait_user_confirm'].includes(detail.status_text)">
                            <img src="@/assets/images/icon-time.png" alt="" class="time-ico" />
                            <div class="time-text">{{remaining_seconds>0 ?'还剩':''}}{{ remaining_seconds | time_format }}</div>
                        </div>
                    </div>
                    <div class="tips">
                        <ul v-if="['create'].includes(detail.status_text)">
                            <li>商家同意后,请按照给出的退货地址退货,并请记录退货运单号</li>
                            <li>如商家拒绝,您可以修改申请后再次发起,商家会重新处理</li>
                            <li>如商家超时未处理,退货申请将自动达成,请按系统给出的退货地址退货</li>
                        </ul>
                        <div v-if="['wait_shop_confirm'].includes(detail.status_text)" class="agree-tips">如果商家收到货并验货无误,将操作退款给您</div>
                        <div class="logistics-box" v-if="['wait_shop_confirm'].includes(detail.status_text)">
                            <div class="logistics-title-box">
                                退货物流:{{ detail.user_logistics_name }}
                            </div>
                            <div class="logistics-no">
                                快递单号:
                                <div class="value">
                                    <div class="value-left">{{ detail.user_logistics_no }}
                                        <Icon type="ios-browsers-outline" class="copy-icon" @click="onCopyLogisticsNo(detail.user_logistics_no)" />
                                    </div>
                                    <span class="view-logistics" @click="viewLogistics(detail.user_logistics_name, detail.user_logistics_no, detail.shop && detail.shop.return_mobile)">查看物流详情</span>
                                </div>
                            </div>
                            <div class="logistics-tips">物流公司未返回数据,请到相应公司官网查询或联系其公式电话</div>
                        </div>
                        <div class="logistics-box" v-if="detail.shop_logistics_no">
                            <div class="logistics-title-box">
                                商家发货:{{ detail.shop_logistics_name }}
                            </div>
                            <div class="logistics-no">
                                快递单号:
                                <div class="value">
                                    <div class="value-left">{{ detail.shop_logistics_no }}
                                        <Icon type="ios-browsers-outline" class="copy-icon" @click="onCopyLogisticsNo(detail.shop_logistics_no)" />
                                    </div>
                                    <span class="view-logistics" @click="viewLogistics(detail.shop_logistics_name, detail.shop_logistics_no, detail.ord && detail.ord.contact_mobile)">查看物流详情</span>
                                </div>
                            </div>
                        </div>
                        <ul v-if="['wait_shop_confirm'].includes(detail.status_text)">
                            <li>如果商家拒绝退款,需要您修改退货申请</li>
                            <li>如果商家超时未处理,将自动退款给您</li>
                        </ul>
                        <div v-if="['wait_user_send'].includes(detail.status_text)" class="agree-tips">商家已同意您的{{detail.type|type_filter}}申请,请尽早退货</div>
                        <div v-if="['wait_user_send', 'shop_reject_receive'].includes(detail.status_text)" class="return-address-box">
                            <div class="return-add-title">
                                <img src="@/assets/images/shop/icon-shop-order-receive.png" alt="" class="icon" />
                                <div class="title">退货地址</div>
                            </div>
                            <div class="address-item">
                                <p>收货人:{{ detail.shop.return_name ||'-' }} {{ detail.shop.return_mobile ||'-'}}</p>
                                <p>收货地址:{{ detail.shop.return_address || '-'}}</p>
                            </div>
                        </div>
                        <ul v-if="detail.status_text == 'wait_user_send'">
                            <li>未与商家协商一致,请勿使用到付或平邮,以免商家拒签货物</li>
                            <li>交易的欠款还在衣创中间账户,确保您资金安全</li>
                            <li>填写真实退货物流信息,逾期未填写,退货申请将自动关闭</li>
                        </ul>
                    </div>
                    <div v-if="['wait_user_send', 'shop_reject_receive'].includes(detail.status_text)" class="user-shipped" @click="show_shipped_back=true">填写退货物流单号</div>
                    <div class="modify-apply" v-if="['create','shop_reject_apply' ].includes(detail.status_text)" @click="onModifyApply">修改申请</div>
                    <div v-if="['wait_user_confirm'].includes(detail.status_text)" class="modify-apply" @click="onConfirmAfterSale">确认收货</div>
                    <div class="also-can-do" v-if="![10,11,12].includes(Number(detail.status))">
                        你还可以:<span @click="onCancelApply">撤销申请</span><template v-if="[1,2].includes(Number(detail.status))">或申请<span class="platform-link" @click="onApplyPlatform">平台介入</span></template>
                    </div>
                    <div class="history">
                        <div class="history-title">协商历史</div>
                        <div class="list-box">
                            <div class="apply-item" v-if="detail.user_send_time">
                                <div class="item-title-box">
                                    <div class="item-title">买家已退货</div>
                                    <div class="item-time">{{ detail.user_send_time }}</div>
                                </div>
                                <div class="item-content-box">
                                    <p>买家已退货,等待商家收货</p>
                                    <p>物流公司:{{ detail.user_logistics_name }}</p>
                                    <p>物流单号:{{ detail.user_logistics_no }}</p>
                                </div>
                            </div>
                            <div class="apply-item" v-if="detail.shop_handle_time">
                                <template v-if="['wait_user_send','wait_shop_confirm','wait_shop_send','wait_user_confirm','complete'].includes(detail.status_text)">
                                    <div class="item-title-box">
                                        <div class="item-title">申请通过</div>
                                        <div class="item-time">{{ detail.shop_handle_time }}</div>
                                    </div>
                                    <div class="item-content-box">
                                        <p>卖家同意{{ detail.type|type_filter }}申请<span v-if="[1,2].includes(Number(detail.type))">,请尽早退回商品</span></p>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="item-title-box">
                                        <div class="item-title">申请拒绝</div>
                                        <div class="item-time">{{ detail.shop_handle_time }}</div>
                                    </div>
                                    <div class="item-content-box">
                                        <p>卖家拒绝{{ detail.type|type_filter }}申请,拒绝原因:{{ detail.shop_reason }}{{ detail.shop_memo ? `,${detail.shop_memo}` : '' }}</p>
                                    </div>
                                </template>
                            </div>
                            <div class="apply-item">
                                <div class="item-title-box">
                                    <div class="item-title">买家提交申请</div>
                                    <div class="item-time">{{ detail.create_time }}</div>
                                </div>
                                <div class="item-content-box">
                                    <p>买家申请{{ detail.type|type_filter }},等待卖家确认</p>
                                    <!-- 换货(type=2)专属:件数与新规格,取自 mall_order_service.new_spec_quantity / newspec -->
                                    <template v-if="Number(detail.type) === 2">
                                        <p>换货数量:{{ detail.new_spec_quantity || 0 }}件</p>
                                        <p>换新规格:{{ new_spec_info }}</p>
                                    </template>
                                    <p>申请原因:{{ detail.user_reason }}</p>
                                    <!-- <p v-if="false">货品情况:已收到货</p> -->
                                    <p>退款/换货说明:{{ detail.user_memo }}</p>
                                    <p>凭证{{ detail.user_proof && detail.user_proof.length > 0 ? '(图片/视频)' : '' }}:</p>
                                    <div class="img-list" v-viewer>
                                        <template v-for="(item,index) in detail.user_proof">
                                            <!-- 处理对象格式 { url, type } -->
                                            <img 
                                                v-if="(typeof item === 'object' && item.type === 'image') || (typeof item === 'string' && util.test_image(item))" 
                                                :src="typeof item === 'object' ? item.url : item" 
                                                alt="" 
                                                :key="`img-${index}`"
                                            />
                                            <div 
                                                v-else-if="((typeof item === 'object' && item.type === 'video') || (typeof item === 'string' && util.is_video(item))) && videoProbeStatus[index] === undefined"
                                                :key="`video-loading-${index}`"
                                                class="img-item video-download-item"
                                            >
                                                <span class="video-download-text">视频检测中...</span>
                                            </div>
                                            <video 
                                                v-else-if="((typeof item === 'object' && item.type === 'video') || (typeof item === 'string' && util.is_video(item))) && videoProbeStatus[index] === true" 
                                                :src="typeof item === 'object' ? item.url : item" 
                                                controls="controls" 
                                                :key="`video-${index}`"
                                                class="img-item"
                                            ></video>
                                            <div 
                                                v-else-if="((typeof item === 'object' && item.type === 'video') || (typeof item === 'string' && util.is_video(item))) && videoProbeStatus[index] === false"
                                                :key="`video-download-${index}`"
                                                class="img-item video-download-item"
                                                @click="util.downloadVideo(typeof item === 'object' ? item.url : item)"
                                                title="该视频编码格式不支持在线播放，点击下载"
                                            >
                                                <img src="@/assets/images/icon-mall-play.png" class="video-download-icon" />
                                                <span class="video-download-text">下载视频</span>
                                            </div>
                                            <!-- 兼容旧数据:直接是URL字符串 -->
                                            <img 
                                                v-else 
                                                :src="typeof item === 'object' ? item.url : item" 
                                                alt="" 
                                                :key="`fallback-${index}`"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-form">
                    <div class="detail-title">订单详情</div>
                    <div class="detail-product-box">
                        <img :src="goods.product_image|default_img" alt="" class="detail-product-img" />
                        <div class="detail-product-info">
                            <div class="product-title">{{goods.product_name}}</div>
                            <div class="product-spec">{{goods.spec_info}}</div>
                        </div>
                    </div>
                    <div class="detail-list-box">
                        <div class="detail-list-item">
                            <div class="list-item-label">卖家:</div>
                            <div class="list-item-value shop-name">
                                {{order_detail.shop_name}} <img  v-if="userInfo.id !=  order_detail.shop.user_id" @click="onChatClick(order_detail.shop.designer_info)" src="@/assets/images/icon-mall-cart-service.png" />
                            </div>
                        </div>
                        <div class="detail-list-item">
                            <div class="list-item-label">订单编号:</div>
                            <div class="list-item-value">{{order_detail.order_no}}</div>
                        </div>
                        <div class="detail-list-item">
                            <div class="list-item-label">单价:</div>
                            <div class="list-item-value">¥{{goods.price|price_format}}*{{goods.quantity}}(订单数量)</div>
                        </div>
                        <div class="detail-list-item">
                            <div class="list-item-label">邮费:</div>
                            <div class="list-item-value">¥{{0|price_format}}</div>
                        </div>
                        <div class="detail-list-item">
                            <div class="list-item-label">商品总价:</div>
                            <div class="list-item-value">¥{{order_detail.total_price|price_format }}</div>
                        </div>
                    </div>
                    <!-- 换货(type=2)专属信息:件数取 new_spec_quantity(售后件数),与上方 goods.quantity(订单数量)区分 -->
                    <div class="exchange-info-box" v-if="Number(detail.type) === 2">
                        <div class="exchange-title">换货信息</div>
                        <div class="exchange-list">
                            <div class="exchange-item">
                                <div class="item-label">售后类型:</div>
                                <div class="item-value">换货</div>
                            </div>
                            <div class="exchange-item">
                                <div class="item-label">换货数量:</div>
                                <div class="item-value highlight">{{ detail.new_spec_quantity || 0 }}件</div>
                            </div>
                            <div class="exchange-item">
                                <div class="item-label">换新规格:</div>
                                <div class="item-value">{{ new_spec_info }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <service-shipped-back v-if="show_shipped_back" :goods="goods" :uuid="service_uuid" @close="show_shipped_back=false" @send-back="onGetServiceDetail" />
        <chat ref="chat"></chat>
        <Modal
            v-model="logisticsTrackingVisible"
            title="物流轨迹"
            footer-hide
            width="900"
            :styles="{ top: '80px' }"
        >
            <logistics-tracking
                :logistics_name="logisticsData.logistics_name"
                :logistics_no="logisticsData.logistics_no"
                :tracking-list="logisticsData.trackingList"
            />
        </Modal>
    </div>
</template>
<script>
import { AfterSaleCancel, AfterSaleConfirm, AfterSaleDetail, AfterSaleApplyPlatform, GetLogisticsTracking, MallOrderDetail } from '@/api/index';
import LogisticsTracking from '@/components/LogisticsTracking.vue';
import { uploadFileToOSS } from "@/utils/oss";
import util from '@/utils/util';
import dayjs from 'dayjs';
import _ from 'lodash';
import { mapState } from 'vuex';
import ServiceShippedBack from '../components/ServiceShippedBack.vue';
export default{
    components:{
        ServiceShippedBack,
        LogisticsTracking
    },
    data(){
        return{
            curr_step:0,
            order_id:'',
            goods_id:'',
            service_uuid:'',
            form:{
                type:'', // 1退货退款 2换货 3仅退款
                user_proof:[], // 用户上传的凭证图片
            },
            apply_step:1,
            show_exchange_goods:false,
            detail:{},
            new_spec:'',
            exchange_num:'',
            count_bot:null,
            remaining_seconds:0,
            order_detail:{},
            show_shipped_back:false,
            util,
            videoProbeStatus:{},
            logisticsTrackingVisible:false,
            logisticsData:{
                logistics_name:'',
                logistics_no:'',
                trackingList:[]
            }
        }
    },
    filters:{
        type_filter(val){
            switch(Number(val)){
                case 1:
                    return '退货退款';
                case 2:
                    return '换货';
                default:
                    return '仅退款';
            }
        },
        status_filter(val){
            switch(val){
                case 'cancel':
                    return '已取消售后';
                case 'platform_reject':
                    return '平台已驳回您的申请';
                case 'complete':
                    if([1,2].includes(Number(this.order.type))){
                        return '退款成功';
                    }
                    return '换货成功';
                case 'wait_user_confirm':
                    return '换货商品已寄出,等待买家确认';
                case 'wait_shop_send':
                    return '等待寄出换货商品';
                case 'wait_shop_confirm':
                    return '原商品已寄回,等待商家确认';
                case 'wait_user_send':
                    return '等待买家寄回商品';
                default:
                    if(this.order.type == 1){
                        return '买家发起退货退款申请';
                    }
                    if(this.order.type == 2){
                        return '买家发起换货申请';
                    }
                    if(this.order.type == 3){
                        return '买家发起仅退款申请';
                    }
            }
        }
    },
    computed:{
        ...mapState({
            shopInfo:state=>state.shopInfo,
            userInfo:state=>state.userInfo,
        }),
        count_down(){
            const {detail} = this;
            const {create_time} = detail;

            //>如果create_time没有值,则返回当前时间+7天,使用dayjs
            if(!create_time){
                return dayjs().add(7,'day').format('YYYY-MM-DD HH:mm:ss');
            }
            //>如果create_time有值,则返回create_time+7天
            return dayjs(create_time).add(7,'day').format('YYYY-MM-DD HH:mm:ss');
        },
        steps(){
            const { detail } = this;
            const {
                type,
                create_time,
                shop_handle_time,
                user_send_time,
                shop_receive_time,
                shop_send_time,
                complete_time,
            } = detail;

            let data = [];

            switch (Number(type)) {
                default:
                    data = [
                        {
                            title: '买家申请退款',
                            dot_active: !_.isNull(create_time),
                            line_active: !_.isNull(create_time)
                        },
                        {
                            title: '卖家处理退款申请',
                            dot_active: !_.isNull(shop_handle_time),
                            line_active: !_.isNull(shop_handle_time) || !_.isNull(create_time)
                        },
                        {
                            title: '退款完毕',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time) || !_.isNull(shop_handle_time)
                        }
                    ];
                    break;
                case 1:
                    data = [
                        {
                            title: '买家申请退货退款',
                            dot_active: !_.isNull(create_time),
                            line_active: !_.isNull(create_time)
                        },
                        {
                            title: '卖家处理退货退款申请',
                            dot_active: !_.isNull(shop_handle_time),
                            line_active: !_.isNull(shop_handle_time) || !_.isNull(create_time)
                        },
                        {
                            title: '买家退货',
                            dot_active: !_.isNull(user_send_time),
                            line_active: !_.isNull(user_send_time) || !_.isNull(shop_handle_time)
                        },
                        {
                            title: '卖家确认收货',
                            dot_active: !_.isNull(shop_receive_time),
                            line_active: !_.isNull(shop_receive_time) || !_.isNull(user_send_time)
                        },
                        {
                            title: '退货退款完毕',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time) || !_.isNull(shop_receive_time)
                        }
                    ];
                    break;
                case 2:
                    data = [
                        {
                            title: '买家申请换货',
                            dot_active: !_.isNull(create_time),
                            line_active: !_.isNull(create_time)
                        },
                        {
                            title: '卖家处理换货申请',
                            dot_active: !_.isNull(shop_handle_time),
                            line_active: !_.isNull(shop_handle_time) || !_.isNull(create_time)
                        },
                        {
                            title: '买家退货',
                            dot_active: !_.isNull(user_send_time),
                            line_active: !_.isNull(user_send_time) || !_.isNull(shop_handle_time)
                        },
                        {
                            title: '卖家确认收货',
                            dot_active: !_.isNull(shop_receive_time),
                            line_active: !_.isNull(shop_receive_time) || !_.isNull(user_send_time)
                        },
                        {
                            title: '卖家换新',
                            dot_active: !_.isNull(shop_send_time),
                            line_active: !_.isNull(shop_send_time) || !_.isNull(shop_receive_time)
                        },
                        {
                            title: '换货完成',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time) || !_.isNull(shop_send_time)
                        }
                    ];
                    break;
            }
            console.log('data',data);
            return data;
        },
        goods(){
            const {detail} = this;
            const {goods} = detail;
            console.log('goods--->',goods);
            if(!goods) return {};
            return goods;
        },
        // 换货(type=2)场景:换新商品规格文案,接口 serviceDetail 已 with(['newspec']) 预加载
        // 后端 ProductSpecModel::getSpecInfoAttr() 已拼成 "尺码，颜色";该字段真实列值为 NULL,故用 attr1_name/attr2_name 兜底
        new_spec_info(){
            const {detail} = this;
            const {newspec} = detail;
            if(!newspec) return '-';
            if(newspec.spec_info) return newspec.spec_info;
            const names = [newspec.attr1_name,newspec.attr2_name].filter(name=>name);
            return names.length ? names.join('，') : '-';
        }
    },
    watch:{

    },
    async mounted(){
        const {order_id,goods_id,service_uuid} = this.$route.query;
        if(!order_id || !goods_id || !service_uuid) return;
        this.order_id = order_id;
        this.goods_id = goods_id;
        this.service_uuid = service_uuid;
        await this.onGetOrderDetail();
        await this.onGetServiceDetail();
        this.startCountdown();
    },
    beforeDestroy(){
        this.clearCountdown();
    },
    methods:{
        onChatClick(user){
            this.$refs["chat"].showChat(user);
        },
        async onConfirmAfterSale(){
            this.$DModal.confirm({
                content:'是否确认收货,确认后将完成此次售后服务',
                onOK:async ()=>{
                    try{
                        const {code,msg} = await AfterSaleConfirm({uuid:this.service_uuid});
                        if(code>0){
                            this.$layer.msg(msg);
                            return;
                        }
                        this.$layer.msg('操作成功~');
                        this.onGetServiceDetail();
                    }catch(e){
                        console.log('err->service-confirm',e);
                        this.$layer.msg(e.msg);
                    }
                }
            })
        },
        onModifyApply(){
            this.$router.push({
                name:'ServiceApply',
                query:{
                    order_id:this.order_detail.uuid,
                    goods_id:this.goods.product_id,
                    og_uuid:this.goods.uuid,
                    service_uuid:this.service_uuid
                }
            })
        },
        onCopyLogisticsNo(logistics_no){
            navigator.clipboard.writeText(logistics_no).then(()=>{
                this.$layer.msg('复制成功~');
            }).catch(e=>{
                console.log('err-copy',e);
            })
        },
        viewLogistics(logistics_name, logistics_no, receiver_phone){
            this.logisticsTrackingVisible = true;
            this.logisticsData = {
                logistics_name,
                logistics_no,
                trackingList: []
            };
            // receiver_phone: 收件人手机号,顺丰等物流需此参数才能查询轨迹
            const params = { logistics_no, logistics_name };
            if(receiver_phone){
                params.phone = receiver_phone;
            }
            GetLogisticsTracking(params).then(res=>{
                if(res.data){
                    this.logisticsData = {
                        logistics_name: res.data.logistics_name || logistics_name,
                        logistics_no: res.data.logistics_no || logistics_no,
                        trackingList: res.data.traceList || []
                    };
                }
            }).catch(e=>{
                console.log('err-logistics-tracking', e);
            });
        },
        onCancelApply(){
            this.$DModal.confirm({
                content:'撤销后,若超出订单服务保障期,将无法再次发起售后申请',
                onOK:async()=>{
                    console.log('aaa=1');
                    try{
                        console.log('aaa');
                        const {code,msg} = await AfterSaleCancel({uuid:this.detail.uuid});
                        if(code>0){
                            this.$layer.msg(msg);
                            return;
                        }
                        this.$layer.msg('操作成功~');
                        this.$router.push({
                            name:'MallOrderCenter'
                        })
                    }catch(e){
                        console.log('err-cancel-service',e);
                        this.$layer.msg(e.msg);
                    }
                }
            })
        },
        onApplyPlatform(){
            this.$DModal.confirm({
                content:'平台介入后,将由客服对本次售后进行裁决,是否继续?',
                onOK:async()=>{
                    try{
                        const {code,msg} = await AfterSaleApplyPlatform({uuid:this.detail.uuid});
                        if(code>0){
                            this.$layer.msg(msg);
                            return;
                        }
                        this.$layer.msg('已提交平台介入~');
                        this.onGetServiceDetail();
                    }catch(e){
                        console.log('err-apply-platform',e);
                        this.$layer.msg(e.msg);
                    }
                }
            })
        },
         // 启动倒计时
        startCountdown() {
            // 只在需要倒计时的状态下启动
            const countdownStatuses = ['create','wait_user_send','wait_shop_confirm','wait_shop_send','wait_user_confirm'];
            if (!countdownStatuses.includes(this.detail.status_text)) {
                return;
            }
            const targetTime = this.count_down; // 获取目标时间
            this.updateRemainingSeconds(targetTime); // 初始化剩余秒数

            // 每秒更新一次
            this.count_bot = setInterval(() => {
                this.updateRemainingSeconds(targetTime);
            }, 1000);
        },

        // 更新剩余秒数
        updateRemainingSeconds(targetTime) {
            const now = dayjs();
            const target = dayjs(targetTime);
            const diff = target.diff(now, 'second'); // 获取秒级差值

            if (diff <= 0) {
                this.remaining_seconds = 0;
                this.clearCountdown(); // 清除定时器
                return;
            }

            this.remaining_seconds = diff; // 更新剩余秒数
        },

        // 清除定时器
        clearCountdown() {
            if (this.count_bot) {
                clearInterval(this.count_bot);
                this.count_bot = null;
            }
        },
        onExchangeGoodsConfirm(data){
            console.log('data',data);
            this.new_spec = data.color_name + ' ' + data.size_name;
            this.form.color_uuid = data.color_uuid;
            this.form.size_uuid = data.size_uuid;
            this.exchange_num = data.num;
            this.show_exchange_goods = false;
        },

        async onGetOrderDetail(){
            try{
                const {code,msg,data} = await MallOrderDetail({uuid:this.order_id});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.order_detail = data;
                console.log('data-order-detail',data);
            }catch(e){
                console.log('err-order-detail',e);
                this.$layer.msg(e.msg);
            }
        },

        async onGetServiceDetail(){
            try{
                const {code,msg,data} = await AfterSaleDetail({uuid:this.service_uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.detail = data;
                console.log('data-service-detail',data);
                this.probeAllVideos(data);
            }catch(e){
                console.log('err-order-detail',e);
                this.$layer.msg(e.msg);
            }
        },
        probeAllVideos(detail){
            const proofs = detail.user_proof || [];
            proofs.forEach((item, index) => {
                const url = typeof item === 'object' ? item.url : item;
                const isVideo = (typeof item === 'object' && item.type === 'video') ||
                    (typeof item === 'string' && util.is_video(item));
                if (!isVideo) return;
                // 初始状态 undefined（加载中）
                this.$set(this.videoProbeStatus, index, undefined);
                util.probeVideoPlayable(url).then((playable) => {
                    this.$set(this.videoProbeStatus, index, playable);
                });
            });
        },
        onProofDel(index){
            this.form.user_proof.splice(index,1);
        },
        onApplyTypeChange(val){
            console.log('val',val);
            this.curr_step = 1;
            this.form.type = val;
        },
        onBeforeUpload(file){
            // console.log('file',file);
            uploadFileToOSS(file,'template').then(res=>{
                if(!this.form.user_proof) this.form.user_proof = [];
                if (this.form.user_proof.length >= 10) {
                    this.$layer.msg('最多只能上传10张图片');
                    return false;
                }
                this.form.user_proof.push(res);
            }).catch(e=>{
                console.log('err-upload',e);
                this.$layer.msg(e.msg);
            })
            return false;
        },
        onOrderList(){
            this.$router.push({
                name:'MallOrderCenter'
            })
        },
        onOrderDetail(){
            this.$router.push({
                name:'OrderDetail',
                query:{
                    uuid:this.order_id,
                    from:'mall'
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.service-apply{
    width:100%;
    height:100%;
    background:#f8f9fb;
    padding:0 94px 120px 30px;
    user-select:none;
    .bread-crumbs{
        display:flex;
        align-items:center;
        column-gap:8px;
        padding-bottom:22px;
        padding-top:20px;
        .crumbs-item{
            color:#999;
            font-size:14px;
            cursor:pointer;
            &:hover, &.active{
                color:#333;
            }
        }
    }
    .apply-body{
        width:100%;
        height:850px;
        padding:40px;
        background:#fff;
        .product-box{
            display:flex;
            column-gap:20px;
            padding-bottom:30px;
            border-bottom:1px solid #e3e3e3;
            .product-img{
                width:96px;
                height:96px;
                border-radius:8px;
                border:1px solid #e3e3e3;
            }
            .product-info{
                display:flex;
                flex-direction:column;
                row-gap:13px;
                .product-name{
                    color:#333;
                    font-size:16px;
                    margin-top:12px;
                }
                .product-spec{
                    color:#666;
                    font-size:14px;
                }
            }
        }
        .service-title{
            color:#333;
            font-size:18px;
            margin-top:30px;
        }
        .service-list{
            display:flex;
            align-items:center;
            margin-top:22px;
            column-gap:20px;
            .service-item{
                width:410px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                padding:25px 20px;
                display:flex;
                column-gap:10px;
                cursor:pointer;
                .service-icon{
                    width:50px;
                    height:50px;
                }
                .service-text-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:6px;
                    .title-text{
                        color:#333;
                        font-size:16px;
                        font-weight:bold;
                    }
                    .title-desc{
                        color:#999;
                        font-size:14px;
                    }
                }
            }
        }
    }
    .apply-body-with-form{
        width:100%;
        min-height:850px;
        background:#fff;
        // padding:40px;
        .top-status-box{
            display:flex;
            align-items:center;
            justify-content:center;
            padding-top:32px;
            border-bottom:1px solid #d6d6d6;
            .step-info{
                $order-red:#ff4d4f;
                $line-gray:#e5e5e5;
                $text-gray:#999;
                display:flex;
                align-items:flex-start;
                justify-content:space-between;
                width:100%;           // 跟随父容器,避免内容撑出
                box-sizing:border-box;
                padding:0 10px 20px 10px;
                .step-item{
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        justify-content:center;
                        position:relative;
                        width:200px;
                        flex-shrink:1;   // 窄屏允许收缩,防止溢出右边界
                        .line{
                        width:calc(100% - 9px);
                        height:1px;
                        background:#e3e3e3;
                        position:absolute;
                        top:4px;
                        left:-48%;
                        &.active{
                            background:$order-red;
                        }
                        }
                        .dot-info-box{
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        justify-content:center;
                        .dot{
                            width:9px;
                            height:9px;
                            border:1px solid #e3e3e3;
                            border-radius:50%;
                            &.active{
                                background:$order-red;
                                border-color:$order-red;
                            }
                        }
                        .title{
                            color:#333;
                            font-size:14px;
                            margin-top:11px;
                            white-space:nowrap;   // 防止文字换行影响连线对齐
                            text-align:center;    // 居中于 step-item,避免最后一项文字贴右被裁
                        }
                        }
                }
            }
        }
        .form-detail-body{
            display:flex;
            justify-content:space-between;
            width:100%;
            height:100%;
            padding:40px 40px 21px 40px;
            .left-form{
                display:flex;
                flex-direction:column;
                flex:1;
                // row-gap:50px;
                .main-status-text{
                    display:flex;
                    align-items:center;
                    column-gap:20px;
                    .status-text{
                        color:#333;
                        font-size:18px;
                        font-weight:bold;
                    }
                    .status-countdown{
                        display:flex;
                        align-items:center;
                        column-gap:4px;
                        .time-ico{
                            width:14px;
                            height:14px;
                        }
                        .time-text{
                            color:#ff5967;
                            font-size:13px;
                        }
                    }
                }
                .tips{
                    box-sizing:border-box;
                    align-self:flex-start;
                    margin-top:16px;
                    width:100%;
                    ul{
                        width:100%;
                        overflow:hidden;
                        margin:0;
                        padding-left:20px;
                        list-style:disc;
                    }
                    .agree-tips{
                        color:#666;
                        font-size:14px;
                        margin-top:10px;
                    }
                    .return-address-box{
                        width:100%;
                        background:#f9fafc;
                        border-radius:10px;
                        padding:24px;
                        margin:24px 0;
                        .return-add-title{
                            display:flex;
                            align-items:center;
                            column-gap:10px;
                            .icon{
                                width:18px;
                                height:21px;
                            }
                            .title{
                                color:#333;
                                font-size:16px;
                            }
                        }
                        .address-item{
                            color:#666;
                            font-size:14px;
                            margin-top:17px;
                            row-gap:10px;
                        }
                    }
                    .logistics-box{
                        width:100%;
                        background:#f9fafc;
                        border-radius:10px;
                        padding:24px;
                        margin:24px 0;
                        .logistics-title-box{
                            display:flex;
                            align-items:center;
                            column-gap:5px;
                            color:#333;
                            font-size:16px;
                        }
                        .logistics-no{
                            display:flex;
                            align-items:center;
                            column-gap:10px;
                            color:#333;
                            font-size:16px;
                            .value{
                                display:flex;
                                align-items:center;
                                column-gap:46px;
                                .value-left{
                                    display:flex;
                                    align-items:center;
                                    column-gap:10px;
                                    .copy-icon{
                                        width:14px;
                                        height:14px;
                                        cursor:pointer;
                                    }
                                }
                                span{
                                    color:#0d99ff;
                                    cursor:pointer;
                                }
                            }
                        }
                        .logistics-tips{
                            margin-top:18px;
                            color:#666;
                            font-size:14px;
                        }
                    }
                }
                .user-shipped{
                    width:250px;
                    height:48px;
                    line-height:48px;
                    text-align:center;
                    color:#fff;
                    background:#ff5967;
                    font-weight:bold;
                    cursor:pointer;
                    margin-top:54px;
                }
                .modify-apply{
                    width: 250px;
                    height:48px;
                    border:1px solid #b3b3b3;
                    border-radius:4px;
                    line-height:48px;
                    text-align:center;
                    cursor:pointer;
                    margin-top:50px;
                    font-size:16px;
                    color:#333;
                }
                .also-can-do{
                    display:flex;
                    align-items:center;
                    column-gap:3px;
                    color:#666;
                    font-size:13px;
                    margin-top:32px;
                    span{
                        color:#0d99ff;
                        cursor:pointer;
                    }
                }
                .history{
                    width:100%;
                    margin-top:108px;
                    .history-title{
                        width:100%;
                        color:#333;
                        font-size:16px;
                    }
                    .list-box{
                        width:100%;
                        margin-top:24px;
                        padding-right:40px;
                        display:flex;
                        flex-direction:column;
                        .apply-item{
                            width:100%;
                            display:flex;
                            flex-direction:column;
                            border-top:1px solid #d6d6d6;
                            padding-top:14px;
                            .item-title-box{
                                width:100%;
                                display:flex;
                                align-items:center;
                                justify-content:space-between;
                                .item-title{
                                    color:#333;
                                    font-size:16px;
                                    font-weight:500;
                                }
                                .item-time{
                                    color:#666;
                                    font-size:14px;
                                }
                            }
                            .item-content-box{
                                color:#666;
                                font-size:14px;
                                margin-top:10px;
                                margin-bottom:24px;
                                p{
                                    line-height:1.5;
                                }
                                .img-list{
                                    display:flex;
                                    column-gap:12px;
                                    margin-top:16px;
                                    img{
                                        width:100px;
                                        height:110px;
                                    }
                                    .video-download-item{
                                        width:100px;
                                        height:110px;
                                        background:#f0f0f0;
                                        display:flex;
                                        flex-direction:column;
                                        align-items:center;
                                        justify-content:center;
                                        cursor:pointer;
                                        border-radius:4px;
                                        gap:6px;
                                        .video-download-icon{
                                            width:24px;
                                            height:24px;
                                        }
                                        .video-download-text{
                                            font-size:12px;
                                            color:#0d99ff;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .right-form{
                width:448px;
                min-height:100%;
                border-left:1px solid #e3e3e3;
                padding-left:38px;
                display:flex;
                flex-direction:column;
                .detail-title{
                    color:#333;
                    font-size:18px;
                }
                .detail-product-box{
                    display:flex;
                    column-gap:20px;
                    .detail-product-img{
                        width:96px;
                        height:96px;
                        border-radius:8px;
                        border:1px solid #e3e3e3;
                    }
                    .detail-product-info{
                        display:flex;
                        flex-direction:column;
                        row-gap:12px;
                        .product-title{
                            color:#333;
                            font-size:16px;
                        }
                        .product-spec{
                            color:#666;
                            font-size:14px;
                        }
                    }
                }
                .detail-list-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:8px;
                    margin-top:24px;
                    .detail-list-item{
                        display:flex;
                        align-items:center;
                        column-gap:15px;
                        .list-item-label{
                            color:#666;
                            font-size:14px;
                            width:70px;
                            text-align:right;
                        }
                        .list-item-value{
                            font-size:14px;
                            color:#333;
                            &.shop-name{
                                cursor:pointer;
                                color:#0d99ff;
                                display:flex;
                                align-items:center;
                                column-gap:4px;
                                img{
                                    width:22px;
                                    height:22px;
                                }
                            }
                        }
                    }
                }
                // 换货(type=2)专属信息区块
                .exchange-info-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    margin-top:24px;
                    padding-top:20px;
                    border-top:1px dashed #e3e3e3;
                    .exchange-title{
                        color:#333;
                        font-size:16px;
                        font-weight:bold;
                    }
                    .exchange-list{
                        display:flex;
                        flex-direction:column;
                        row-gap:8px;
                        .exchange-item{
                            display:flex;
                            align-items:center;
                            column-gap:15px;
                            .item-label{
                                color:#666;
                                font-size:14px;
                                width:70px;
                                text-align:right;
                                flex-shrink:0;
                            }
                            .item-value{
                                font-size:14px;
                                color:#333;
                                &.highlight{
                                    color:#ff5967;
                                    font-weight:bold;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff5967;
    &::after{
        background-color:#ff5967;
    }
}
::v-deep .ivu-radio-focus {
    -webkit-box-shadow: 0 0 0 2px #ff596733;
    box-shadow: 0 0 0 2px #ff596733;
    z-index: 1;
    &::after{
        background-color:#ff5967;
    }
}
</style>
